import { ofType } from 'redux-observable';
import { EMPTY, from, Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import {
    LOAD_MOBILE_INSTALLED_APPS_DATA,
    MobileInstalledAppsDataLoadAction
} from '../../actions/internalGroups/loadMobileInstalledAppsData';
import { loadTagCloudTargeting, TagCloudTargetingLoadAction } from '../../actions/tagCloudTargeting';
import {
    mobileAppTagRenderedValueFactory,
    mobileAppTagValidationFactory
} from '../../service/InternalGroupHelpers/InternalGroupHelpers';
import { DnaEpic } from '../../typings/epic';
import { AppInfo } from '../../typings/mobile-apps';
import { TagState } from '../../typings/tagCloudTargeting';

/**
 * Загружает информацию о мобильных приложениях по указанному массиву URL-ов
 * По завершении загрузки валидирует и устанавливает значения тегам в редакторе
 * таргетингов
 *
 * @param action$
 * @param store$
 * @param deps
 */
export const loadMobileInstalledAppsDataEpic: DnaEpic = (
    action$,
    store$,
    deps
): Observable<TagCloudTargetingLoadAction> => {
    return action$.pipe(
        ofType(LOAD_MOBILE_INSTALLED_APPS_DATA),
        mergeMap((action: MobileInstalledAppsDataLoadAction) => {
            const { editorId, shouldValueBeSaved } = action;
            const { login } = store$.value.commonData;
            const editor = store$.value.tagCloudTargetingEditor[editorId];
            const newTags = editor.tags.filter(tag => tag.tagState === TagState.LOADING);

            if (newTags.length === 0) {
                return EMPTY;
            }

            const appUrls = newTags.map(tag => tag.value[0]);
            const appInfoPromise: Promise<AppInfo[]> = deps.restApiManager.getMultipleAppsInfo(appUrls, login);

            return from(appInfoPromise).pipe(
                mergeMap((apps: AppInfo[]) => {
                    return of(
                        loadTagCloudTargeting(
                            editorId,
                            shouldValueBeSaved,
                            mobileAppTagValidationFactory(apps),
                            mobileAppTagRenderedValueFactory(apps)
                        )
                    );
                })
            );
        })
    );
};
